export default __webpack_public_path__ + "static/media/image1pro1.c2922afb.jpeg";